import React, { createContext, useState } from 'react';

export const NotificationType = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  INFO: 'info',
};
const { SUCCESS } = NotificationType;

// This'll get much cleaner after TypeScript

/**
 * @typedef {Object} button
 * @property {string} id
 * @property {string} label
 * @property {Function} onClick
 * @property {boolean} filled
 * @property {boolean} disabled
 */

const defaults = {
  showNotificationBar: false,
  notificationBarText: '',
  /**
   * @type {('success'|'warning'|'error'|'info')}
   */
  notificationBarType: SUCCESS,
  alignLeft: false,
  /**
   * @type {Array.<button>}
   */
  buttons: [],
  /**
   * @type {React.ReactNode}
   */
  rightContents: undefined,
  /**
   * @type {function(boolean): void}
   */
  setShowNotificationBar: () => {},
  /**
   * @type {function(string): void}
   */
  setNotificationBarText: () => {},
  /**
   * @type {function(('success'|'warning'|'error'|'info')): void}
   */
  setNotificationBarType: () => {},
  /**
   * @type {function(boolean): void}
   */
  setAlignLeft: () => {},
  /**
   * @type {function(Array.<button>): void}
   */
  setButtons: () => {},
  /**
   * @type {function(React.ReactNode): void}
   */
  setRightContents: () => {},
};

export const NotificationBarContext = createContext(defaults);

// Hook to manage context state, to then be passed into provider
export const useNotificationBar = () => {
  /**
   * @type {[boolean, function(boolean): void]}
   */
  const [showNotificationBar, setShowNotificationBar] = useState(
    defaults.showNotificationBar
  );
  /**
   * @type {[string, function(string): void]}
   */
  const [notificationBarText, setNotificationBarText] = useState(
    defaults.notificationBarText
  );
  /**
   * @type {[('success'|'warning'|'error'|'info'), function(('success'|'warning'|'error'|'info')): void]}
   */
  const [notificationBarType, setNotificationBarType] = useState(
    defaults.notificationBarType
  );
  /**
   * @type {[boolean, function(boolean): void]}
   */
  const [alignLeft, setAlignLeft] = useState(defaults.alignLeft);
  /**
   * @type {[Array.<button>, function(Array.<button>): void]}
   */
  const [buttons, setButtons] = useState(null);
  /**
   * @type {[React.ReactNode, function(React.ReactNode): void]}
   */
  const [rightContents, setRightContents] = useState(null);

  const contextValue = {
    showNotificationBar,
    notificationBarText,
    notificationBarType,
    alignLeft,
    buttons,
    rightContents,
    setShowNotificationBar,
    setNotificationBarText,
    setNotificationBarType,
    setAlignLeft,
    setButtons,
    setRightContents,
  };

  return contextValue;
};
